import { useMutation, useQuery } from "@apollo/client";
import React, { useState, useContext, useEffect } from "react";
import beneficiary from "../../gql/beneficiary";

// import { ToastContainer, toast } from "react-toastify";
import toast from "react-hot-toast";
import { appContext } from "../../context/ContextProvider";
import { useNavigate } from "react-router-dom";

import "./style/payerlist.css";
import Pagination from "../../components/Pagination";
import physicians from "../../gql/physicians";
import AppModal from "../../components/AppModal";
import ConformationModal from "../../components/ConformationModal";
// import FilterModal from "./FilterModal";
import ptpa from "../../gql/ptpa";

import ImportPayerModal from "./ImportPayerModal";

import SearchPayerList from "./SearchPayerList";
import priceList from "../../gql/priceList";
import { LuTrash2 } from "react-icons/lu";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import PriceListFilter from "./components/PriceListFilter";
import { Button, Tooltip } from "@mui/material";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import AddIcon from "@mui/icons-material/Add";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { useTranslation } from "react-i18next";
import TableLoader from "../../common/TableLoader";
import OuterPriceListServiceModal from "./OuterPriceListServiceModal";
import AppButton from "../../shared/AppButton";
import AppTable from "../../shared/AppTable";
import TableSkeletonLoader from "../../common/TableLoading";
import { FaFilter } from "react-icons/fa";

function PriceListMain() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [payers, setPayers] = useState([]);
  const { permissions } = useContext(appContext);
  const [item, setItem] = useState(null);

  const [showSearchForm, setShowSearchForm] = useState(false);
  const [showImportPriceListModal, setShowImportPriceListModal] =
    useState(false);
  const [showOuterPriceListServiceModal, setShowOuterPriceListServiceModal] =
    useState(false);

  const [showFilters, setShowFilters] = useState(() => {
    const saved = sessionStorage.getItem("priceListShowFilters");
    return saved !== null ? JSON.parse(saved) : false;
  });

  useEffect(() => {
    sessionStorage.setItem("priceListShowFilters", JSON.stringify(showFilters));
  }, [showFilters]);

  const [showDeleteAlert, setShowDeleteAlert] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);

  const [limit, setLimit] = useState(10);
  const [pageNo, setPageNo] = useState(1);
  const [tableLoading, setTableLoading] = useState(false);

  const [delEntry, { loading: delLoading }] = useMutation(
    priceList.DELETE_PRICE_LIST,
    {
      update(proxy, result) {
        onSuccessfulRequestResponse(result.data);
      },
      onError(error) {
        onResponseError(error.graphQLErrors[0]);
      },
    },
  );

  const onSuccessfulRequestResponse = (data) => {
    if (data?.deletePriceList) {
      toast.success(data?.deletePriceList?.message);
      refetch({
        input: {
          limit: limit,
          page: pageNo,
        },
      });
    }
  };

  const onResponseError = (error) => {
    toast.error(`${error.message}`);
  };

  const {
    loading: dataLoading,
    error,
    data,
    refetch,
  } = useQuery(priceList.LIST_PRICE_LIST, {
    variables: {
      input: {
        limit: limit,
        page: pageNo,
      },
    },
  });

  const onPageChange = (currentPage) => {
    setPageNo(currentPage);
    refetch({
      input: {
        limit: limit,
        page: currentPage,
      },
    });
  };

  const onClickDelete = (item) => {
    setCurrentItem(item);
    setShowDeleteAlert(true);
  };

  const deleteEntry = () => {
    delEntry({
      variables: {
        input: {
          effective_date: currentItem.effective_date,
          payer_id: currentItem.payer_id,
          id: 0,
        },
      },
    });
    setShowDeleteAlert(false);
  };

  const onClickEdit = (el) => {
    navigate("/physicians/edit/form/" + el.id);
  };

  const handleDownloadClick = () => {
    const fileUrl = "/PriceListSample.xlsx";

    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = "priceListSample.xlsx";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  React.useEffect(() => {
    const payersData = JSON.parse(localStorage.getItem("payersData"));
    if (payersData && payersData.length > 0) {
      setPayers(payersData);
    } else {
      navigate("/dashboard");
    }
  }, []);

  function formatDate(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const seconds = date.getSeconds().toString().padStart(2, "0");
    return `${month}/${day}/${year} ${hours}:${minutes}:${seconds}`;
  }

  const columns = [
    {
      header: t("SQ #"),
      render: (row, index) => pageNo * limit + index + 1 - limit,
    },
    {
      header: t("Payer"),
      render: (row) => (
        <span className="capitalize font-medium text-slate-700">
          {row.payer_name.length > 100 ? (
            <Tooltip title={row.payer_name}>
              <span>{row.payer_name.slice(0, 100)}...</span>
            </Tooltip>
          ) : (
            row.payer_name
          )}
        </span>
      ),
    },
    { header: t("TPA"), field: "tpa_name" },
    {
      header: t("Effective Date"),
      render: (row) => row.effective_date?.substring(0, 10),
    },
    {
      header: t("Upload Date"),
      render: (row) => formatDate(row.created_at),
    },
  ];

  return (
    <div className="priceList_container !p-0">
      <div className="flex justify-between flex-col lg:flex-row gap-4 mb-2">
        <div className="flex w-full gap-1.5 flex-col md:flex-row justify-end">
          <AppButton
            label={t("Filter Toggle")}
            variant="outlined"
            onClick={() => setShowFilters(!showFilters)}
            startIcon={<FaFilter className="!text-[12px]" />}
            className="!border-[#2441c9] !text-[#2441c9] hover:!bg-primary/10"
          />
          <AppButton
            label={t("Download Sample")}
            variant="outlined"
            onClick={handleDownloadClick}
            startIcon={<FileDownloadOutlinedIcon className="!text-[18px]" />}
            className="!border-[#2441c9] !text-[#2441c9] hover:!bg-primary/10"
          />
          <AppButton
            label={t("Import Price List")}
            onClick={() => setShowImportPriceListModal(true)}
            startIcon={<AddIcon />}
          />
          <AppButton
            label={t("Add Price List Service")}
            onClick={() => setShowOuterPriceListServiceModal(true)}
            startIcon={<AddIcon />}
          />
        </div>
      </div>

      {showFilters && (
        <div className="bg-white border border-slate-200 rounded-lg p-2 mb-2">
          <PriceListFilter
            refetch={refetch}
            setLoading={setTableLoading}
            pageNo={pageNo}
            limit={limit}
          />
        </div>
      )}

      <AppTable
        columns={columns}
        data={data?.listPriceList?.data}
        loading={dataLoading || delLoading || tableLoading}
        onView={(row) =>
          navigate(
            `/price-list/specific/${row.payer_id}/${row.effective_date}/${row.payer_name}`,
          )
        }
        onDelete={onClickDelete}
        LoaderComponent={
          <TableSkeletonLoader columnCount={columns.length + 1} rowCount={10} />
        }
      />

      <Pagination
        currentPage={pageNo}
        totalPages={data?.listPriceList?.pages}
        onPageChange={onPageChange}
      />

      <ConformationModal
        open={showDeleteAlert}
        setOpen={setShowDeleteAlert}
        onDelete={deleteEntry}
      />
      <ImportPayerModal
        showImportPriceListModal={showImportPriceListModal}
        setShowImportPriceListModal={setShowImportPriceListModal}
        payersData={payers}
        refetchPriceList={refetch}
        pageNo={pageNo}
        limit={limit}
      />
      <OuterPriceListServiceModal
        setShowPriceListServiceModal={setShowOuterPriceListServiceModal}
        showPriceListServiceModal={showOuterPriceListServiceModal}
        payersData={payers}
      />
    </div>
  );
}

export default PriceListMain;
